// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"nG1TO","heading1":"L4xsI","suffix":"EvTOR","links-list-title":"onBBK","header":"JiWIq","more-btn":"n2lvq","special-slider-title":"WnTCc"};